import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, AlertCircle } from "lucide-react";
import { api } from "../lib/api";
import { Card } from "./ui/card";
import { isoToDisplay as tgl } from "./DateInput";

export const PengumumanWidget = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/pengumuman/dashboard").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  if (!items || items.length === 0) return null;
  return (
    <Card className="p-4 sm:p-5 rounded-2xl border-slate-200/80" data-testid="dashboard-pengumuman-card">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <div className="flex items-center gap-3"><div className="h-11 w-11 rounded-xl bg-rose-100 text-rose-700 flex items-center justify-center"><Megaphone className="h-5 w-5" /></div>
          <div><div className="text-xs sm:text-sm text-slate-600">Pengumuman</div><div className="text-sm font-semibold text-slate-900">{items.length} pengumuman aktif terbaru</div></div></div>
        <Link to="/pengumuman" className="text-sm font-semibold text-[hsl(224,64%,33%)] hover:underline min-h-[44px] inline-flex items-center" data-testid="dashboard-pengumuman-link">Lihat Semua →</Link>
      </div>
      <div className="grid md:grid-cols-3 gap-3">
        {items.map((p) => (
          <Link key={p.id} to={`/pengumuman?id=${p.id}`} className={`rounded-xl border p-3 hover:bg-slate-50 transition-colors block ${p.penting ? "border-rose-300 bg-rose-50/40" : "border-slate-200"}`} data-testid={`dashboard-pengumuman-${p.id}`}>
            <div className="flex items-start gap-2">{p.penting && <AlertCircle className="h-4 w-4 text-rose-600 shrink-0 mt-0.5" />}<div className="min-w-0"><div className="font-semibold text-sm text-slate-900 line-clamp-2">{p.judul}</div><div className="text-xs text-slate-600 mt-1 line-clamp-3 whitespace-pre-line">{p.isi}</div></div></div>
            <div className="text-[11px] text-slate-500 mt-2">{tgl(p.tanggal_mulai)}{p.tanggal_selesai ? ` – ${tgl(p.tanggal_selesai)}` : ""} · {p.dibuat_oleh_nama}</div>
          </Link>))}
      </div>
    </Card>
  );
};
